<template>
    <div id="registerTotal">
        <my-header></my-header>
        <!--        <header class="registerHeader">-->
<!--            <div class="main-container">-->
<!--                <h1 class="left_h">-->
<!--                    <a class="logoImg" href="javascript:;" @click="toIndex">-->
<!--                        <img src="../../assets/images/topBar1/logoIcon.png"/>-->
<!--                    </a>-->
<!--                    <span v-if="!type">供应商注册</span>-->
<!--                </h1>-->
<!--                <div class="right_h">-->
<!--                    <a href="javascript:;" @click="toHelp" class="help">帮助中心</a>-->
<!--                    <span class="line"></span>-->
<!--                    <a href="javascript:;" class="wechat">微信服务号</a>-->
<!--                </div>-->
<!--            </div>-->
<!--        </header>-->

        <div class="main-container">
            <div class="container">
                <section class="small-container">
                    <div style="text-align: right; margin-bottom: 10px;" v-if="!supplierId">
                        <el-button type="primary" size="mini" @click="toIndex">退出注册</el-button>
                        <el-button type="primary" size="mini" @click="submit()">提交注册信息</el-button>
                    </div>
                    <div style="text-align: right; margin-bottom: 10px;" v-if="!type && supplierId">
                        <el-button type="primary" size="mini" @click="toIndex">返回</el-button>
                        <el-button type="primary" v-if="suppliersVO.supplierStatus == 1 || suppliersVO.supplierStatus == 7" size="mini" @click="submit()">提交审核</el-button>
                    </div>
                </section>
                <div v-if="isBiddingFlag == 1">
                    <section style="font-size: 14px; background: #f5f5f5; line-height: 30px; padding: 0 10px; color:#606266;" v-if="supplierId && suppliersVO.supplierStatus == 1">
                    <!-- <section style="font-size: 14px; background: #f5f5f5; line-height: 30px; padding: 0 10px; color:#606266;"> -->
                        退回原因：{{suppliersVO.backReason}}
                    </section>
                    <section class="small-container">
                        <h3 class="iconfont iconxiala">选择投标项目</h3>
                        <el-row class="colorLine">
                            <el-col :span="10">
                                <div style="height: 1px;background: #91002c;"></div>
                            </el-col>
                            <el-col :span="14">
                                <div style="height: 1px;background: #003570;"></div>
                            </el-col>
                        </el-row>
                        <el-form :disabled="isReadOnly" status-icon inline :model="supplierBidOrPrice" :rules="supplierBidOrPriceRules" ref="supplierBidOrPrice" :label-width="formLabelWidth">
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="招标/采集：" prop="bidOrPrice" class="noMarginBottom">
                                        <el-radio-group v-model="supplierBidOrPrice.bidOrPrice" @change="handleClear">
                                            <el-radio :label="0">项目招标</el-radio>
                                            <el-radio :label="1">价格采集</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item v-if="supplierBidOrPrice.bidOrPrice == 0" label="项目名称:" prop="projectOrRegionId">
                                        <span style="color: red;position: absolute;left: -80px;">*</span>
                                        <el-select
                                            filterable
                                            v-model="supplierBidOrPrice.projectOrRegionId"
                                            size="mini"
                                            class="minWidth"
                                            @change="$forceUpdate()"
                                            placeholder="请选择">
                                            <el-option
                                                v-for="item in items"
                                                :key="item.id"
                                                :label="item.projectName"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item v-else label="价格集采:" prop="projectOrRegionId">
                                        <span style="color: red;position: absolute;left: -80px;">*</span>
                                        <el-select
                                            clearable
                                            filterable
                                            @change="$forceUpdate()"
                                            size="mini"
                                            v-model="supplierBidOrPrice.projectOrRegionId">
                                            <el-option v-for="item in regionalCompanyListPrice" :key="item.id" :label="item.regionalCompanyName" :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                  <el-form-item label="招标类别：" prop="supplierCategoryName">
                                    <el-input v-model.trim="supplierBidOrPrice.supplierCategoryName" @focus="chooseCategory" size="mini" readonly class="minWidth" placeholder="请选择供应商分类">
                                        <i slot="suffix" class="iconfont iconjiansuo" @click="chooseCategory"></i>
                                    </el-input>
                                  </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </section>
                    <section class="small-container">
                        <h3 class="iconfont iconxiala">联系方式</h3>
                        <el-row class="colorLine">
                            <el-col :span="10">
                                <div style="height: 1px;background: #91002c;"></div>
                            </el-col>
                            <el-col :span="14">
                                <div style="height: 1px;background: #003570;"></div>
                            </el-col>
                        </el-row>
                        <div v-for="(contactFormItem,index) in contactForm" :key="index">
                            <h4 v-if="contactFormItem.mainFlag == 1">主联系人：</h4>
                            <h4 v-else>联系人
                                <span v-if="!isReadOnly">
    <!--                                <span @click="addContact" class="add iconfont iconjiahaoyou">新增</span>-->
                                    <span class="add dele" @click="removeContact(index)">删除</span>
                                </span>
                            </h4>
                            <el-form :disabled="isReadOnly" :model="contactFormItem" inline status-icon :ref="'contactForm'+index" :rules="contactRules" :label-width="formLabelWidth" class="contactForm" style="padding-bottom: 20px;">
                                <el-row >
                                    <el-col :span="12">
                                        <el-form-item label="联系人：" prop="contactName" class="noMarginBottom">
                                            <el-input size="mini" class="minWidth" v-model="contactFormItem.contactName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="职务及职位：" prop="positionName" class="noMarginBottom">
                                            <el-input size="mini" class="minWidth" v-model="contactFormItem.positionName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="手机：" prop="mobile" class="noMarginBottom">
                                            <el-input size="mini" @change="handleChange(index, contactFormItem)" class="minWidth" :maxlength="11" v-model.trim="contactFormItem.mobile"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="电子邮件：" prop="email" class="noMarginBottom">
                                            <el-input size="mini" class="minWidth" v-model="contactFormItem.email"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="社保缴费证明：" class="noMarginBottom attachmentForm" prop="secureAttachement">
                                            <page-upload
                                                    :files="contactFormItem.secureAttachement||[]"
                                                    :editFlag="!isReadOnly"
                                                    :attachmentType="47">
                                            </page-upload>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="劳动合同证明：" class="noMarginBottom attachmentForm" prop="contractAttachement">
                                            <page-upload
                                                    :files="contactFormItem.contractAttachement||[]"
                                                    :editFlag="!isReadOnly"
                                                    :attachmentType="48">
                                            </page-upload>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                            <h4 v-if="contactForm.length == index+1" style="margin-bottom: 20px">联系人
                                <span v-if="!isReadOnly">
                                    <span @click="addContact" class="add iconfont iconjiahaoyou">新增</span>
                                </span>
                            </h4>
                        </div>
                    </section>
                    <section class="small-container" v-if="!supplierId">
                        <h3 class="iconfont iconxiala">注册信息</h3>
                        <el-row class="colorLine">
                            <el-col :span="10">
                                <div style="height: 1px;background: #91002c;"></div>
                            </el-col>
                            <el-col :span="14">
                                <div style="height: 1px;background: #003570;"></div>
                            </el-col>
                        </el-row>
                        <el-form :disabled="isReadOnly" status-icon inline :model="userRequestVO" :rules="userRequestVORules" ref="userRequestVO" :label-width="formLabelWidth">
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="登录名：" prop="userName" class="noMarginBottom">
                                        <el-input v-model.trim="userRequestVO.userName"
                                                size="mini"
                                                disabled
                                                :clearable="isClearable"
                                                class="minWidth"
                                                placeholder="请输入手机号"></el-input>
                                                <span style="color: #F56C6C;font-size: 12px;top: 0;left: 100px;">无需填写，自动抓取主联系人手机号</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label="验证码：" prop="verificationCode" class="noMarginBottom veriCodeItem">
                                        <el-input v-model="userRequestVO.verificationCode" class="minWidth" size="mini" placeholder="请输入收到的验证码"></el-input>
                                        <el-button @click="sendCode" size="mini" class="sendCode" :loading="isSendLoading">发送验证码</el-button>
                                        <!-- <span class="countDown">60s</span> -->
                                        <span class="countDown" style="display:none;">60s</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label="密码：" prop="password" class="noMarginBottom">
                                        <el-input v-model.trim="userRequestVO.password" type="password"
                                                size="mini"
                                                :clearable="!isReadOnly"
                                                class="minWidth"
                                                placeholder="密码由6－20个英文字母(区分大小写)或数字组成"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label="再次输入密码：" prop="enPassword" class="noMarginBottom">
                                        <el-input v-model.trim="userRequestVO.enPassword" type="password"
                                                size="mini"
                                                :clearable="!isReadOnly"
                                                class="minWidth"
                                                placeholder="请再输入一遍您上面填写的密码"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label="企业logo：" prop="logoAttachement" class="noMarginBottom attachmentForm">
                                        <page-upload
                                        @finishUpload="(fileList)=>{this.finishUpload(46, fileList)}"
                                        :files="userRequestVO.logoAttachement"
                                        :editFlag="isClearable"
                                        :attachmentType="46">
                                        </page-upload>
                                        <span style="color: #F56C6C;font-size: 12px;position: absolute;top: 0;left: 100px;">文件大小不能高于2M</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24" v-if="isReadOnly">
                                    <el-form-item label="企业注册时间：">
                                        {{suppliersVO.registerTime}}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </section>
                    <section class="small-container" v-else>
                        <h3 class="iconfont iconxiala">注册信息</h3>
                        <el-row class="colorLine">
                            <el-col :span="10">
                                <div style="height: 1px;background: #91002c;"></div>
                            </el-col>
                            <el-col :span="14">
                                <div style="height: 1px;background: #003570;"></div>
                            </el-col>
                        </el-row>
                        <el-form :disabled="isReadOnly" status-icon inline :model="userRequestVO" :rules="userRequestVORules" ref="userRequestVO" :label-width="formLabelWidth">
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="登录名："  prop="userName" class="noMarginBottom">
                                        <el-input v-model.trim="userRequestVO.userName"
                                                :disabled='(supplierId && supplierId.length>0)'
                                                size="mini"
                                                :clearable="isClearable"
                                                class="minWidth"
                                                placeholder="请输入手机号"></el-input>
                                        <el-button type="primary" size="mini" @click="chagePwd" style="margin-left: 10px;">修改密码</el-button>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label="企业logo：" class="noMarginBottom attachmentForm">
                                        <page-upload
                                        @finishUpload="(fileList)=>{this.finishUpload(46, fileList)}"
                                        :files="userRequestVO.logoAttachement"
                                        :editFlag="!isReadOnly"
                                        :attachmentType="46">
                                        </page-upload>
                                        <span style="color: #F56C6C;font-size: 12px;top: 0;left: 100px;">文件大小不能高于2M</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24" v-if="isReadOnly">
                                    <el-form-item label="注册时间：">
                                        {{suppliersVO.registerTime}}
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </section>
                    <section class="small-container">
                        <h3 class="iconfont iconxiala">企业信息</h3>
                        <el-row class="colorLine">
                            <el-col :span="10">
                                <div style="height: 1px;background: #91002c;"></div>
                            </el-col>
                            <el-col :span="14">
                                <div style="height: 1px;background: #003570;"></div>
                            </el-col>
                        </el-row>
                        <el-form :disabled="isReadOnly" status-icon inline :model="suppliersVO" :rules="suppliersVORules" ref="suppliersVO" :label-width="formLabelWidth">
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="企业名称：" prop="companyName" class="noMarginBottom">
                                        <el-input v-model.trim="suppliersVO.companyName"
                                                size="mini"
                                                class="minWidth"
                                                :clearable="!isReadOnly"
                                                placeholder="请输入企业名称"></el-input>
                                        <el-button @click="queryByQcc" size="mini">企查查</el-button>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label="纳税人状态：" prop="taxipayerStatus" class="noMarginBottom">
                                        <el-select
                                            size="mini"
                                            class="minWidth"
                                            v-model="suppliersVO.taxipayerStatus"
                                            placeholder="请选择">
                                            <el-option
                                                v-for="item in taxiOptions"
                                                :key="item.dictValue"
                                                :label="item.dictLabel"
                                                :value="item.dictValue">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col v-if="suppliersVO.creditLicenseCodeFlag == 1" :span="24">
                                    <el-form-item label="营业执照号/统一社会信用代码：" prop="socialCreditCode" class="noMarginBottom">
                                        <el-radio-group v-model="suppliersVO.creditLicenseCodeFlag">
                                            <el-radio :label="1">统一社会信用代码</el-radio>
                                            <el-radio :label="2">营业执照号</el-radio>
                                        </el-radio-group>
                                        <el-input required  size="mini" class="minWidth" v-model="suppliersVO.socialCreditCode" :maxlength="18" type="text" placeholder="请输入18位数字或字母" style="margin-left: 10px;"></el-input>
                                        <!-- <span class="tip">(提示：三证合一的企业必须选择‘统一社会信用代码’)</span> -->
                                    </el-form-item>
                                </el-col>
                                <el-col v-else :span="24">
                                    <el-form-item label="营业执照号/统一社会信用代码：" prop="businessLicenseNumber" class="noMarginBottom">
                                        <el-radio-group v-model="suppliersVO.creditLicenseCodeFlag">
                                            <el-radio :label="1">统一社会信用代码</el-radio>
                                            <el-radio :label="2">营业执照号</el-radio>
                                        </el-radio-group>
                                        <el-input required size="mini" class="minWidth" v-model="suppliersVO.businessLicenseNumber" type="text" :maxlength="15" placeholder="请输入13-15位数字或字母"  style="margin-left: 10px;"></el-input>
                                        <!-- <span class="tip">(提示：三证合一的企业必须选择‘统一社会信用代码’)</span> -->
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item v-if="suppliersVO.creditLicenseCodeFlag == 2" label="税务登记证号：" prop="taxCertificateNumber" class="noMarginBottom">
                                        <el-input size="mini"
                                                class="minWidth" v-model="suppliersVO.taxCertificateNumber"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="组织机构代码证号：" v-if="suppliersVO.creditLicenseCodeFlag == 2"  prop="orgCertificateNumber" class="noMarginBottom">
                                        <el-input size="mini"
                                                class="minWidth" v-model="suppliersVO.orgCertificateNumber"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="服务城市(主)：" prop="mainIntentionRegionalCompanyId" class="noMarginBottom">
                                        <el-select
                                            @change="mainChanged"
                                            filterable
                                            v-model="suppliersVO.mainIntentionRegionalCompanyId"
                                            size="mini"
                                            class="minWidth"
                                            placeholder="请选择">
                                            <el-option
                                                v-for="item in regionalCompanyList"
                                                :key="item.id"
                                                :label="item.regionalCompanyName"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="服务城市(其他)：" prop="intentionRegionalCompanyIdsArr" class="noMarginBottom">
                                        <el-select
                                            collapse-tags
                                            @change="selectedIntentionRegional"
                                            filterable
                                            v-model="suppliersVO.intentionRegionalCompanyIdsArr"
                                            size="mini"
                                            class="minWidth"
                                            multiple placeholder="请选择">
                                            <el-option
                                                :disabled="item.id == suppliersVO.mainIntentionRegionalCompanyId"
                                                v-for="item in regionalCompanyList"
                                                :key="item.id"
                                                :label="item.regionalCompanyName"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="总部地址：" prop="headquartersAddress" class="noMarginBottom">
                                        <el-input v-model.trim="suppliersVO.headquartersAddress"
                                                size="mini"
                                                class="minWidth"
                                                :clearable="!isReadOnly"
                                                placeholder="请输入总部地址"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-row>
                                        <el-col :span="24">
                                            <el-form-item label="企业性质：" prop="enterpriseCharacterize" class="noMarginBottom">
                                                <el-select
                                                    size="mini"
                                                    class="minWidth"
                                                    v-model="suppliersVO.enterpriseCharacterize"
                                                    placeholder="请选择">
                                                    <el-option
                                                        v-for="item in companyOptions"
                                                        :key="item.dictValue"
                                                        :label="item.dictLabel"
                                                        :value="item.dictValue">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <!-- <el-col v-if="suppliersVO.enterpriseCharacterize == '5'" :span="14">
                                            <el-form-item prop="enterpriseCharacterizeRemark">
                                                <el-input
                                                    size="mini"
                                                    class="minWidth"
                                                    v-model="suppliersVO.enterpriseCharacterizeRemark"
                                                    placeholder="选择'其他'需填写">
                                                </el-input>
                                            </el-form-item>
                                        </el-col> -->
                                    </el-row>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="官网地址："  class="noMarginBottom">
                                        <el-input
                                            placeholder="请输入官网地址"
                                            size="mini"
                                            class="minWidth"
                                            :clearable="!isReadOnly"
                                            v-model="suppliersVO.officialWebUrl">
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="企业注册地址：" prop="enterpriseRegistAddress"  class="noMarginBottom">
                                        <el-input
                                            placeholder="请输入企业注册地址"
                                            size="mini"
                                            class="minWidth"
                                            :clearable="!isReadOnly"
                                            v-model="suppliersVO.enterpriseRegistAddress">
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="法定代表人：" prop="legalRepresentative" class="noMarginBottom">
                                        <el-input
                                            placeholder="请输入法定代表人"
                                            size="mini"
                                            class="minWidth"
                                            :clearable="!isReadOnly"
                                            v-model="suppliersVO.legalRepresentative">
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="企业注册年份：" prop="enterpriseRegistrationYear" class="noMarginBottom">
                                        <el-date-picker
                                            v-model="suppliersVO.enterpriseRegistrationYear"
                                            size="mini"
                                            class="minWidth"
                                            :clearable=false
                                            align="right"
                                            type="month"
                                            id="buildDate"
                                            format="yyyy-MM"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            placeholder="请选择日期">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label="注册资本：" class="noMarginBottom" prop="registeredCapital" :rules="{
                                        validator: 'regexp',
                                        pattern: /^(([0-9]+)|([0-9]+\.[0-9]{0,2}))$/,
                                        message: '正数,最多2位小数', trigger: 'blur'
                                    }">
                                        <el-input
                                            placeholder="注册资本"
                                            size="mini"
                                            :clearable="!isReadOnly"
                                            class="minWidth"
                                            v-model="suppliersVO.registeredCapital">
                                        </el-input>万元
                                        <span class="tip">（提示：外企请手动根据最新汇率换算成人民币，以此作为后期入围标准条件）</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label="办公面积（m²）：" class="noMarginBottom" prop="officeArea" :rules="{
                                        validator: 'regexp',
                                        pattern: /^(([0-9]+)|([0-9]+\.[0-9]{0,2}))$/,
                                        message: '正数,最多2位小数', trigger: 'blur'
                                    }">
                                        <el-input
                                            placeholder="办公面积（m²）"
                                            size="mini"
                                            class="minWidth"
                                            :clearable="!isReadOnly"
                                            v-model="suppliersVO.officeArea">
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                                <!-- <el-col :span="24">
                                    <el-form-item label="上传相关附件：" class="noMarginBottom attachmentForm">
                                        <page-upload
                                                @finishUpload="(fileList)=>{this.finishUpload(12, fileList)}"
                                                :files="suppliersVO.otherAttachement"
                                                :editFlag="!isReadOnly"
                                                :attachmentType="12">
                                        </page-upload>
                                    </el-form-item>
                                </el-col> -->
                                <el-col :span="24">
                                    <el-row>
                                    <el-col :span="12">
                                            <el-form-item label="营业执照号/统一社会信用代码：" prop="creditLicenseAttachments" class="noMarginBottom attachmentForm">
                                                <page-upload
                                                        @finishUpload="(fileList)=>{this.finishUpload(2, fileList)}"
                                                        :files="suppliersVO.creditLicenseAttachments"
                                                        :editFlag="true"
                                                        :attachmentType="2">
                                                </page-upload>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="税务登记证号附件：" prop="taxCertificateNumberAttachments" class="noMarginBottom attachmentForm">
                                                <page-upload
                                                        @finishUpload="(fileList)=>{this.finishUpload(50, fileList)}"
                                                        :files="suppliersVO.taxCertificateNumberAttachments"
                                                        :editFlag="true"
                                                        :attachmentType="50">
                                                </page-upload>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                    <el-col :span="12">
                                            <el-form-item label="组织机构代码证号附件：" prop="institutionAttachments" class="noMarginBottom attachmentForm">
                                                <page-upload
                                                        @finishUpload="(fileList)=>{this.finishUpload(51, fileList)}"
                                                        :files="suppliersVO.institutionAttachments"
                                                        :editFlag="true"
                                                        :attachmentType="51">
                                                </page-upload>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="办公环境：" class="noMarginBottom attachmentForm">
                                                <page-upload
                                                        @finishUpload="(fileList)=>{this.finishUpload(52, fileList)}"
                                                        :files="suppliersVO.officeAttachments"
                                                        :editFlag="true"
                                                        :attachmentType="52">
                                                </page-upload>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row>
                                    <el-col :span="12">
                                            <el-form-item label="增值税一般纳税人申请认定表：" class="noMarginBottom attachmentForm">
                                                <page-upload
                                                        @finishUpload="(fileList)=>{this.finishUpload(3, fileList)}"
                                                        :files="suppliersVO.taxAttachments"
                                                        :editFlag="true"
                                                        :attachmentType="3">
                                                </page-upload>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="上年审计报告或年营业额证明：" class="noMarginBottom attachmentForm">
                                                <page-upload
                                                        @finishUpload="(fileList)=>{this.finishUpload(4, fileList)}"
                                                        :files="suppliersVO.auditAttachments"
                                                        :editFlag="true"
                                                        :attachmentType="4">
                                                </page-upload>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                        </el-form>
                    </section>
                    <section class="small-container">
                        <h3 class="iconfont iconxiala">单位银行信息</h3>
                        <div v-for="(supplierBankAccount,index) in supplierBankAccounts" :key="index">
                            <h4 v-if="supplierBankAccounts.length>1">银行信息
                                <span v-if="!isReadOnly && index != 0" class="add dele" @click="removeBankInfo(index)">删除</span>
                            </h4>
                            <el-form :disabled="isReadOnly" status-icon inline :model="supplierBankAccount" :rules="bankRules" :ref="'supplierBankAccount'+index" :label-width="formLabelWidth">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="银行联行号：" class="noMarginBottom" prop="accountNo">
                                        <el-input v-model.trim="supplierBankAccount.accountNo"
                                                size="mini"
                                                :clearable="!isReadOnly"
                                                class="minWidth"
                                                placeholder="请输入银行联行号"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="开户银行：" class="noMarginBottom" prop="bankName">
                                        <el-input v-model.trim="supplierBankAccount.bankName"
                                                size="mini"
                                                :clearable="!isReadOnly"
                                                class="minWidth"
                                                placeholder="请输入开户银行"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="开户名称：" class="noMarginBottom" prop="accountName">
                                        <el-input v-model.trim="supplierBankAccount.accountName"
                                                size="mini"
                                                :clearable="!isReadOnly"
                                                class="minWidth"
                                                placeholder="请输入开户名称"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="银行账号：" class="noMarginBottom" prop="bankNo">
                                        <el-input v-model.trim="supplierBankAccount.bankNo"
                                                size="mini"
                                                :clearable="!isReadOnly"
                                                class="minWidth"
                                                placeholder="请输入银行账号"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="地区代码：" class="noMarginBottom" prop="areaCode">
                                        <el-input v-model.trim="supplierBankAccount.areaCode"
                                                size="mini"
                                                :clearable="!isReadOnly"
                                                class="minWidth"
                                                placeholder="请输入地区代码"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="币种：" class="noMarginBottom" prop="accountType">
                                        <el-select
                                            class="minWidth"
                                            size="mini"
                                            v-model="supplierBankAccount.accountType"
                                            placeholder="请选择">
                                            <el-option
                                                v-for="item in moneyTypeOptions"
                                                :key="item.dictValue"
                                                :label="item.dictLabel"
                                                :value="item.dictValue">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="省份：" class="noMarginBottom" prop="areaProvince">
                                        <el-select
                                            class="minWidth"
                                            @change="handelSelectChangeFunc($event,index)"
                                            size="mini"
                                            v-model="supplierBankAccount.areaProvince"
                                            placeholder="请选择">
                                            <el-option
                                                v-for="item in provinceList"
                                                :key="item.areaId"
                                                :label="item.areaName"
                                                :value="item.areaId">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="市县：" class="noMarginBottom" prop="areaCity">
                                        <el-select
                                            class="minWidth"
                                            size="mini"
                                            @change="cityValue"
                                            v-model="supplierBankAccount.areaCity"
                                            placeholder="请选择">
                                            <el-option
                                                v-for="item in supplierBankAccount.areaCityList"
                                                :key="item.areaId"
                                                :label="item.areaName"
                                                :value="item.areaId">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            </el-form>
                            <h4 v-if="supplierBankAccounts.length == index+1 && !isReadOnly" style="margin-bottom: 20px">银行信息
                                <span>
                                    <span @click="addBankInfo" class="add iconfont iconjiahaoyou">新增</span>
                                </span>
                            </h4>
                        </div>
                    </section>
                    <section class="small-container" v-if="(lstSuppliersQualificationGradeVO && lstSuppliersQualificationGradeVO.length > 0) || !isReadOnly">
                        <h3 class="iconfont iconxiala">企业资质<span class="add iconfont iconjiahaoyou" @click="addNatural">新增</span><span class="tips" style="margin-right: 20px;">提示：资质有多个时请依次新增</span></h3>
                        <el-row class="colorLine">
                            <el-col :span="10">
                                <div style="height: 1px;background: #91002c;"></div>
                            </el-col>
                            <el-col :span="14">
                                <div style="height: 1px;background: #003570;"></div>
                            </el-col>
                        </el-row>
                        <el-form v-if="isHideNatural" :label-width="formLabelWidth" class="naturalForm">
                            <el-form-item label="资质等级：" >
                                <span>无</span>
                                <span class="tip">（提示：若无资质需要选择，请继续填写下方信息）</span>
                            </el-form-item>
                        </el-form>
                        <div v-else v-for="(naturalFormItem,index) in lstSuppliersQualificationGradeVO" :key="index" >
                            <h4 >企业资质
                                <span v-if="!isReadOnly">
                                    <!-- <span v-if="index == 1" @click="addContact" class="add"><img src="../../assets/images/register/btn02.png"/></span> -->
                                    <span class="add dele" @click="removeNatural(index)">删除</span>
                                </span>
                            </h4>
                            <el-form :disabled="isReadOnly"
                                status-icon
                                :model="naturalFormItem"
                                :rules="naturalRules"
                                :ref="'naturalForm'+index"
                                :label-width="formLabelWidth"
                                inline
                                class="naturalForm">
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="资质名称：" class="noMarginBottom" prop="qualificationName">
                                            <el-input v-model.trim="naturalFormItem.qualificationName"
                                                    size="mini"
                                                    :clearable="!isReadOnly"
                                                    class="minWidth"
                                                    placeholder="请输入资质名称"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="资质证书编号：" class="noMarginBottom" prop="certificateNumber">
                                            <el-input v-model.trim="naturalFormItem.certificateNumber"
                                                    size="mini"
                                                    :clearable="!isReadOnly"
                                                    class="minWidth"
                                                    placeholder="请输入资质证书编号"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="资质证书有效期：" class="noMarginBottom" prop="validityPeriod">
                                            <el-date-picker
                                                v-model="naturalFormItem.validityPeriod"
                                                size="mini"
                                                class="minWidth"
                                                :clearable=false
                                                align="right"
                                                type="date"
                                                format="yyyy-MM-dd"
                                                value-format="yyyy-MM-dd HH:mm:ss"
                                                placeholder="请选择资质证书有效期">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="资质等级：" class="noMarginBottom">
                                            <el-input v-model.trim="naturalFormItem.gradeLevel"
                                                    size="mini"
                                                    :clearable="!isReadOnly"
                                                    class="minWidth"
                                                    placeholder="请输入资质等级"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item label="资质证书附件：" class="noMarginBottom">
                                            <page-upload
                                                    :files="naturalFormItem.attachmentVOList"
                                                    :editFlag="true"
                                                    :attachmentType="8">
                                            </page-upload>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </div>

                    </section>
                    <section class="small-container" v-if="(suppliersAchievenVO && suppliersAchievenVO.length > 0) || !isReadOnly">
                        <h3 class="iconfont iconxiala">
                            <span >业绩信息（请填写与本次招标相关的业绩内容，至少3个）</span>
                            <span class="add iconfont iconjiahaoyou" @click="addStrategy">新增</span>
                        </h3>
                        <el-row class="colorLine">
                            <el-col :span="10">
                                <div style="height: 1px;background: #91002c;"></div>
                            </el-col>
                            <el-col :span="14">
                                <div style="height: 1px;background: #003570;"></div>
                            </el-col>
                        </el-row>
                        <el-form
                            :disabled="isReadOnly"
                            status-icon inline
                            :model="suppliersAchievenVOItem"
                            v-for="(suppliersAchievenVOItem,index) in suppliersAchievenVO"
                            :key="index"
                            :rules="suppliersAchievenRules"
                            :ref="'suppliersAchievenVO'+index"
                            :label-width="formLabelWidth"
                            class="suppliersAchievenVO">
                            <h4 >业绩信息 <span style="font-size: 12px;color: #F56C6C;" v-if="!isReadOnly"></span>
                                <span v-if="!isReadOnly">
                                    <!-- <span v-if="index == 1" @click="addContact" class="add"><img src="../../assets/images/register/btn02.png"/></span> -->
                                    <span class="add dele" v-if="index!=0" @click="removeStrategy(index)">删除</span>
                                </span>
                            </h4>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="合同名称：" class="noMarginBottom" prop="contactName">
                                        <el-input
                                            size="mini"
                                            class="minWidth"
                                            v-model="suppliersAchievenVOItem.contactName">
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="合同签约日期：" class="noMarginBottom" prop="signTime">
                                        <el-date-picker
                                            v-model="suppliersAchievenVOItem.signTime"
                                            size="mini"
                                            class="minWidth"
                                            :clearable=false
                                            align="right"
                                            type="date"
                                            :id="'cooperativeStartTime'+index"
                                            format="yyyy-MM-dd"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            placeholder="请选择日期">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="合同额度：" prop="signContactPrice" class="noMarginBottom">
                                        <el-input size="mini" class="unit" v-model="suppliersAchievenVOItem.signContactPrice" oninput ="value=value.replace(/[^0-9.]/g,'')"></el-input>万元
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label="合同附件:" class="noMarginBottom attachmentForm" prop="lstattachmentVO">
                                        <page-upload :files="suppliersAchievenVOItem.lstattachmentVO||[]"
                                                        :editFlag="true"
                                                        :attachmentType="1"
                                                        :limitType="1"
                                                    :isIconTable="1"></page-upload>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </section>
                    <section class="small-container">
                        <h3 class="iconfont iconxiala">补充资料</h3>
                        <el-row class="colorLine">
                            <el-col :span="10">
                                <div style="height: 1px;background: #91002c;"></div>
                            </el-col>
                            <el-col :span="14">
                                <div style="height: 1px;background: #003570;"></div>
                            </el-col>
                        </el-row>
                        <el-form :disabled="isReadOnly" status-icon inline :model="otherAttachementVO" :label-width="formLabelWidth">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="补充资料：" class="noMarginBottom attachmentForm">
                                        <page-upload
                                                @finishUpload="(fileList)=>{this.finishUpload(53, fileList)}"
                                                :files="otherAttachementVO.attachments"
                                                :editFlag="true"
                                                :attachmentType="53">
                                        </page-upload>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </section>
                    <section class="small-container" v-if="2">
                        <h3 class="iconfont iconxiala">修改说明</h3>
                        <el-row class="colorLine">
                            <el-col :span="10">
                                <div style="height: 1px;background: #91002c;"></div>
                            </el-col>
                            <el-col :span="14">
                                <div style="height: 1px;background: #003570;"></div>
                            </el-col>
                        </el-row>
                        <el-form :disabled="isReadOnly" status-icon inline :model="suppliersVO" :label-width="formLabelWidth">
                            <el-row style="margin-top: 10px;">
                                <el-col :span="24">
                                    <el-form-item label="修改说明：" class="noMarginBottom remarkForm">
                                        <el-input
                                            type="textarea"
                                            :maxlength="500"
                                            size="mini"
                                            :rows="5"
                                            class="miniWidth"
                                            placeholder="请输入内容"
                                            v-model="suppliersVO.remarks"
                                            >
                                            </el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </section>
                </div>
                <div v-else>
                    <div class="container">
                        <section class="small-container top10">
                            <h3 class="iconfont iconxiala">联系方式</h3>
                            <el-row class="colorLine">
                                <el-col :span="10">
                                    <div style="height: 1px;background: #91002c;"></div>
                                </el-col>
                                <el-col :span="14">
                                    <div style="height: 1px;background: #003570;"></div>
                                </el-col>
                            </el-row>
                            <div v-for="(contactFormItem,index) in contactForm" :key="index">
                                <el-form :disabled="isReadOnly" :model="contactFormItem" inline status-icon :ref="'contactForm'+index" :rules="contactRules" :label-width="formLabelWidth" class="contactForm">
                                    <el-row >
                                        <h4 v-if="index == 0">主联系人：</h4>
                                        <h4 v-else>联系人
                                                <span class="add dele" @click="removeContact(index)">删除</span>
                                        </h4>
                                        <el-col :span="12">
                                            <el-form-item label="联系人：" prop="contactName" class="noMarginBottom">
                                                <el-input size="mini" class="minWidth" v-model="contactFormItem.contactName"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="手机：" prop="mobile" class="noMarginBottom">
                                                <el-input size="mini" class="minWidth" @change="handleChange(index, contactFormItem)" :maxlength="11" v-model.trim="contactFormItem.mobile"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <!-- <h4 v-if="contactForm.length == index+1" style="margin-bottom: 20px">联系人
                                        <span v-if="!isReadOnly">
                                            <span @click="addContact" class="add iconfont iconjiahaoyou">新增</span>
                                        </span>
                                    </h4> -->
                                </el-form>
                            </div>
                        </section>
                        <section class="small-container top10">
                            <h3 class="iconfont iconxiala">注册信息</h3>
                            <el-row class="colorLine">
                                <el-col :span="10">
                                    <div style="height: 1px;background: #91002c;"></div>
                                </el-col>
                                <el-col :span="14">
                                    <div style="height: 1px;background: #003570;"></div>
                                </el-col>
                            </el-row>
                            <el-form status-icon inline-message inline :model="userRequestVO" :rules="userRequestVORules" ref="userRequestVO" :label-width="formLabelWidth">
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item label="登录名：" prop="userName" class="noMarginBottom">
                                            <el-input
                                                disabled
                                                v-model.trim="userRequestVO.userName"
                                                size="mini"
                                                :clearable="isClearable"
                                                class="minWidth"
                                                placeholder="请输入供应商用于登录的手机号码"></el-input>
                                                <!-- <span class="tip">请输入供应商用于登录的手机号码</span> -->
                                                <span style="color: #F56C6C;font-size: 12px;top: 0;left: 100px;">无需填写，自动抓取主联系人手机号</span>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </section>
                        <section class="small-container top10">
                            <h3 class="iconfont iconxiala">企业信息</h3>
                            <el-row class="colorLine">
                                <el-col :span="10">
                                    <div style="height: 1px;background: #91002c;"></div>
                                </el-col>
                                <el-col :span="14">
                                    <div style="height: 1px;background: #003570;"></div>
                                </el-col>
                            </el-row>
                            <el-form status-icon inline :model="suppliersVO" :rules="suppliersVORules" ref="suppliersVO" :label-width="formLabelWidth">
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item label="企业名称：" prop="companyName" class="noMarginBottom">
                                            <el-input v-model.trim="suppliersVO.companyName"
                                                    size="mini"
                                                    class="minWidth"
                                                    placeholder="请输入企业名称"></el-input>
                                            <el-button @click="queryByQcc" type="primary" size="mini">企查查</el-button>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <el-form-item label="服务城市：" prop="mainIntentionRegionalCompanyId" class="noMarginBottom">
                                            <el-select
                                                filterable
                                                v-model="suppliersVO.mainIntentionRegionalCompanyId"
                                                @change="selectedIntentionRegional"
                                                size="mini"
                                                class="minWidth"
                                                placeholder="请选择">
                                                <el-option
                                                    v-for="item in this.regionalCompanyList"
                                                    :key="item.id"
                                                    :label="item.regionalCompanyName"
                                                    :value="item.id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="营业执照号：" prop="businessLicenseNumber" class="noMarginBottom">
                                            <el-input
                                                placeholder="请输入13-15位数字或字母"
                                                size="mini"
                                                class="minWidth"
                                                v-model="suppliersVO.businessLicenseNumber" :maxlength="15">
                                                </el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                            <el-form-item label="法定代表人：" prop="legalRepresentative" class="noMarginBottom">
                                                <el-input
                                                    placeholder="请输入法定代表人"
                                                    size="mini"
                                                    class="minWidth"
                                                    v-model="suppliersVO.legalRepresentative">
                                                </el-input>
                                            </el-form-item>
                                        </el-col>
                                </el-row>
                            </el-form>
                        </section>
                        <section class="small-container top10">
                            <h3 class="iconfont iconxiala">单位银行信息</h3>
                            <el-row class="colorLine">
                                <el-col :span="10">
                                    <div style="height: 1px;background: #91002c;"></div>
                                </el-col>
                                <el-col :span="14">
                                    <div style="height: 1px;background: #003570;"></div>
                                </el-col>
                            </el-row>
                            <div>
                                <div v-for="(supplierBankAccount,index) in supplierBankAccounts" :key="index">
                                    <h4 v-if="(supplierBankAccounts.length >1 && isReadOnly) || (supplierBankAccounts.length >0 && !isReadOnly)">银行信息
                                        <span v-if="!isReadOnly && index != 0" class="add dele" @click="removeBankInfo(index)">删除</span>
                                    </h4>
                                    <el-form :disabled="isReadOnly" status-icon inline :model="supplierBankAccount" :rules="supplierBankAccountRules" ref="supplierBankAccount" :label-width="formLabelWidth">
                                        <el-row>
                                            <el-col :span="12">
                                                <el-form-item label="银行联行号：" class="noMarginBottom" prop="accountNo">
                                                    <el-input v-model.trim="supplierBankAccount.accountNo"
                                                            size="mini"
                                                            :clearable="!isReadOnly"
                                                            class="minWidth"
                                                            placeholder="请输入银行联行号"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="开户银行：" class="noMarginBottom" prop="bankName">
                                                    <el-input v-model.trim="supplierBankAccount.bankName"
                                                            size="mini"
                                                            :clearable="!isReadOnly"
                                                            class="minWidth"
                                                            placeholder="请输入开户银行"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="开户名称：" class="noMarginBottom" prop="accountName">
                                                    <el-input v-model.trim="supplierBankAccount.accountName"
                                                            size="mini"
                                                            :clearable="!isReadOnly"
                                                            class="minWidth"
                                                            placeholder="请输入开户名称"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="银行账号：" class="noMarginBottom" prop="bankNo">
                                                    <el-input v-model.trim="supplierBankAccount.bankNo"
                                                            size="mini"
                                                            :clearable="!isReadOnly"
                                                            class="minWidth"
                                                            placeholder="请输入银行账号"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="地区代码：" class="noMarginBottom" prop="areaCode">
                                                    <el-input v-model.trim="supplierBankAccount.areaCode"
                                                            size="mini"
                                                            :clearable="!isReadOnly"
                                                            class="minWidth"
                                                            placeholder="请输入地区代码"></el-input>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="币种：" class="noMarginBottom" prop="accountType">
                                                    <el-select
                                                        class="minWidth"
                                                        size="mini"
                                                        v-model="supplierBankAccount.accountType"
                                                        placeholder="请选择">
                                                        <el-option
                                                            v-for="item in moneyTypeOptions"
                                                            :key="item.dictValue"
                                                            :label="item.dictLabel"
                                                            :value="item.dictValue">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="省份：" class="noMarginBottom" prop="areaProvince">
                                                    <el-select
                                                        class="minWidth"
                                                        @change="handelSelectChangeFunc($event,index)"
                                                        size="mini"
                                                        v-model="supplierBankAccount.areaProvince"
                                                        placeholder="请选择">
                                                        <el-option
                                                            v-for="item in provinceList"
                                                            :key="item.areaId"
                                                            :label="item.areaName"
                                                            :value="item.areaId">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="12">
                                                <el-form-item label="市县：" class="noMarginBottom" prop="areaCity">
                                                    <el-select
                                                        class="minWidth"
                                                        size="mini"
                                                        @change="cityValue($event,index)"
                                                        v-model="supplierBankAccount.areaCity"
                                                        placeholder="请选择">
                                                        <el-option
                                                            v-for="item in supplierBankAccount.areaCityList"
                                                            :key="item.areaId"
                                                            :label="item.areaName"
                                                            :value="item.areaId">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-form>
                                    <h4 v-if="supplierBankAccounts.length == index+1 && !isReadOnly" style="margin-bottom: 20px">银行信息
                                        <span>
                                            <span @click="addBankInfo" class="add iconfont iconjiahaoyou">新增</span>
                                    </span>
                                    </h4>
                                </div>
                            </div>
                        </section>
                        
                    </div>
                </div>
            </div>
            <el-dialog title="选择供方分类"
                    width="30%"
                    :close-on-click-modal="$root.dialogAutoClose"
                    :close-on-press-escape="$root.dialogAutoClose"
                    :visible.sync="treeDialog">
                <div style="max-height: 300px;overflow-y: auto;">
                    <el-tree :data="treeData"
                            :props="$root.treeProps"
                            highlight-current
                            :expand-on-click-node="false"
                            :show-checkbox="true"
                            :default-checked-keys="defaultCheckedKeys"
                            node-key="id"
                            ref="categoryTree"
                            @node-click="handleClickChange"></el-tree>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="treeDialog = false">取 消</el-button>
                    <el-button type="primary" @click="treeConfirm">确 定</el-button>
                </span>
            </el-dialog>
            <el-dialog
                id="article"
                title="注册须知"
                :visible.sync="centerDialogVisible"
                :close-on-click-modal='showModal'
                :close-on-press-escape='showModal'
                :show-close='showModal'
                width="50%"
                top="10vh"
                center>
                <div>
                    <h3 class="center">欢迎您在此注册为合生商业招标采购服务平台会员！</h3>
                    <section>
                        <h3 class="center">提 示</h3>
                        <p class="indent padd">
                            请仔细阅读下述文本，合生商业招标采购服务平台依据以下服务条款提供您所享有的服务，如果您接受，请点按“同意”进入注册页面。 请您仔细阅读并充分理解本文本。本文本采用电子签署、点击提交方式, 您自愿点选"同意"并完成注册, 即视为已完全同意并接受本文本内容, 并愿受其约束。您若不同意本文本的任何条款, 请不要点选 "同意"。
                        </p>
                    </section>
                    <p class="indent padd">
                        合生商业招标采购服务平台各项电子服务的所有权和运作权归合生商业。合生商业招标采购服务平台提供的服务将完全按照其发布的章程、服务条款和操作规则严格执行。用户必须完全同意所有服务条款并完成注册程序，才能成为合生商业招标采购服务平台的正式会员，这也意味着用户与合生商业招标采购服务平台达成协议并接受所有的服务条款。
                    </p>
                    <ul>
                        <li>
                            <h3>一、 定义：</h3>
                            <div class="padd">
                                <p class="indent">如无特别说明，下列术语在本章程中的含义为：</p>
                                <p class="indent">“公司”：指合生商业；</p>
                                <p class="indent">“网站”：指合生商业招标采购服务平台；</p>
                                <p class="indent">“用户”：指使用合生商业招标采购服务平台的所有因特网用户；</p>
                                <p class="indent">“会员”：指合生商业招标采购服务平台的正式会员；</p>
                                <p class="indent">“服务条款”： 指本章程所列明的所有服务和约定内容；</p>
                                <p class="indent">“网上交易”：指网站借助因特网技术为会员提供的建材项目招、投标和产品采购、销售交易活动；</p>
                            </div>
                        </li>
                        <li>
                            <h3>二、 会员资料：</h3>
                            <div class="padd">
                                <p class="indent">基于合生商业招标采购服务平台所提供的网络服务的重要性，会员应同意：</p>
                                <ul class="indent">
                                    <li>(1)向网站提供及时、详尽及准确真实的用户资料。</li>
                                    <li>(2)不断更新注册资料，符合及时、详尽、准确的要求。所有原始键入的资料网站将引用为注册资料。 网站对会员注册资料和交易资料有保密义务。</li>
                                    <li>(3)网站为统计分析、内部管理之目的，有权使用会员资料。 在得到会员许可的情况下，网站可以将客户资料向第三方提供。会员向网站提供的信息将只被用于订货和为会员提供更好的服务。</li>
                                    <li>(4)即使未得到会员的明确许可，网站仍可根据法律规定向有权查询的法定机构提供会员资料，或为交易的需要向第三方提供必要的客户资料。</li>
                                    <li>(5)会员的个人资料如有变更，应及时通知网站，否则由此发生的风险和责任由会员自行承担。</li>
                                </ul>
                            </div>
                        </li>
                        <li>
                            <h3>三、 会员的用户名和密码：</h3>
                            <p class="indent padd">网站发给会员的用户名和密码是网站在提供网上交易过程中识别会员的唯一依据。会员须妥善保管用户名和密码。无论会员实际上是否将用户名和密码提供给他人使用，均须对该用户名和密码下进行的一切活动和交易事件负责。如用户名或密码遗失、被盗，会员应立即通知网站，对报失之前发生的交易自行承担后果。但会员可按照规定申请发放新的用户名和密码。如会员将密码遗忘或怀疑密码已被他人知悉，可按规定随时在网站变更密码。</p>
                        </li>
                        <li>
                            <h3>四、 网上服务功能：</h3>
                            <dl class="padd">
                                <dt class="indent">（一）信息服务：服务对象是所有因特网用户，具体功能包括：</dt>
                                <dd>（1）网站的基本信息发布，包括网站简介、网站导航；</dd>
                                <dd>（2）招标采购产品信息发布，包括产品分类、产品介绍、产品的市场动态等；</dd>
                                <dd>（3）网站建材采购项目的招标信息发布；</dd>
                                <dd>（4）新闻发布，涉及房地产行业和建材行业的行业信息；</dd>
                                <dd>（5）通告，所有发给用户的通告包括：服务条款的修改、服务变更、或其它重要事件的通告都通过重要页面的公告或电子邮件或常规的信件形式传送。</dd>
                                <dt class="indent">（二）会员服务：服务对象是网站的正式会员，除包括信息服务功能外，还包括：</dt>
                                <dd>（1）招标项目中标查询；</dd>
                                <dd>（2）会员用户名、密码变更、报失；</dd>
                                <dd>（3）会员网上反馈意见的处理；</dd>
                                <dd>（4）会员网上投诉的处理。</dd>
                            </dl>
                        </li>
                        <li>
                            <h3>五、服务约定：</h3>
                            <dl class="padd">
                                <dt class="indent">（一）网站运用自己的操作系统通过国际互联网络为用户提供网络服务。同时，用户必须：</dt>
                                <dd>(1) 自行负担个人上网所支付的与此服务有关的电话费用、网络费用；</dd>
                                <dd>(2) 自行配备上网的所需设备， 包括个人电脑、调制解调器或其他必备上网装置。</dd>
                                <dt class="indent">（二）信息发布</dt>
                                <dd>
                                    <p class="indent">1、用户对服务的使用标准是根据所有适用于同类网站的国家法律、地方性法规和国际惯例制定的。用户使用网络过程中必须遵守：</p>
                                    <p class="indent2">(1)不得以非法目的使用网络服务；</p>
                                    <p class="indent2">(2)不干扰或扰乱网络服务。</p>
                                    <p class="indent2">用户的行为准则是遵守根据因特网法规、政策和惯例，用户承诺不传输任何不符合国家法律、当地法规和国际惯例的信息资料。另外，用户也不能传输任何教唆他人构成犯罪行为的资料；不能传输助长国内不利条件和涉及国家安全的资料。未经许可而非法进入其它电脑系统是禁止的。若用户的行为不符合以上提到的服务条款，网站将做出独立判断并立即终止向其提供网络服务。用户需对自己在网上的行为独立承担法律责任。用户若在网站上散布和传播反动、色情或其他违反国家法律法规的信息，网站的系统记录有可能作为用户违反法律的证据。</p>
                                </dd>
                                <dd class="indent">2、用户单独承担就发布内容所产生的责任。用户在发表的信息中加入宣传资料或参与广告策划，要遵守国家有关广告方面的法律法规，保证不侵犯他人合法权益。用户在网站上采取的任何促销方法（如展示他们的产品），及就运输货物、付款、服务、商业条件、担保及、广告等达成交条件都只约束相应的用户和广告销售商，公司不承担任何责任，网站不对这类广告的内容及其后果承担任何法律责任。另外，网站不对用户所发布信息的删除或储存失败负责。</dd>
                                <dt class="indent">（三）网络服务内容的所有权</dt>
                                <dd class="indent">网站所提供的包括文字、软件、声音、图片、录像、图表、广告中的全部内容，以及网站为用户提供的其他信息。所有这些内容受版权、商标等有关法律的保护。所以，用户只能在网站和广告商授权下才能使用这些内容，而不能擅自复制、改编这些内容、或创造与内容有关的派生产品。网站所有的文章版权归原文作者和网站共同所有，任何人需要转载网站的文章，必须经原文作者和网站同意和授权。</dd>
                            </dl>
                        </li>
                        <li>
                            <h3>六、 网上公示的内容：</h3>
                            <dl class="padd">
                                <dt class="indent">网上公示的服务对象是网站的正式会员。具体功能包括：</dt>
                                <dd>（1）网上招标，即实现采购方会员在网站进行建材项目的采购招标；</dd>
                                <dd>（2）网上投标，即实现供应商会员根据网上招标要求在网站投递标书；</dd>
                                <dd>（3）网上开标，即在网站公布中标结果。</dd>
                            </dl>
                        </li>
                        <li>
                            <h3>七、章程条款的修改和服务修订：</h3>
                            <p class="indent padd">网站有权在必要时修改章程中的服务条款，网站服务条款一旦发生变动，将会在重要页面上提示修改内容。如果不同意所改动的内容，用户可以主动取消获得的网络服务。如果用户继续享用网络服务，则视为接受服务条款的变动。网站保留随时修改或终止服务的权利。</p>
                        </li>
                        <li>
                            <h3>八、 终止服务：</h3>
                            <p class="indent padd">用户可以行使终止使用网络服务的权利，如果用户违背了章程服务条款的规定，网站有终止对其提供网络服务的权利，但终止方须提前10个工作日以书面或电子邮件方式通知对方。服务终止意味客户会员资格的取消，但服务终止并不意味着终止前所发生的未完成交易的撤销，也不能消除因终止前的交易所带来的任何法律后果。</p>
                        </li>
                        <li>
                            <h3>九、 法律适用和效力：</h3>
                            <div class="padd">
                                <p class="indent">本章程是对会员与网站的其他既有协议和约定的补充而非替代，如本章程与其他既有协议和约定有冲突，应以本章程为准。</p>
                                <p class="indent">本章程的任何条款如因任何原因而被确认无效，都不影响本协议其他条款的效力。</p>
                                <p class="indent">本章程自网站审核会员通过之日起生效。</p>
                            </div>
                        </li>
                        <li>
                            <h3>十、 章程的解释：</h3>
                            <p class="indent">本章程由合生商业招标采购服务平台负责解释。</p>
                        </li>
                    </ul>
                </div>
                <div slot="footer" class="dialog-footer">
                    <p class="readed">
                        <el-checkbox v-model="checked">已阅读注册须知</el-checkbox>
                    </p>
                    <el-button class="disagree" type="primary" @click="toLogin">不同意</el-button>
                    <el-button  @click="toRegister">同意</el-button>
                </div>
            </el-dialog>
        </div>
        <select-category ref="selectCategory" @callback="selectedCategory"></select-category>
    </div>

</template>
<script>
import SelectPriceLibrary from "./selectPriceLibrary";
import MyHeader from '../common/Header.vue'
import md5 from 'js-md5';
import axios from 'axios';
    import {registerRules,naturalRules, contactRules, bankRules, suppliersAchievenRules} from '@/util/rules'
    export default {
        components:{
            MyHeader,
            SelectPriceLibrary
        },
        name: "add-supplier",
        props: {
            detailType: {
                type: String
            },
            id: {
                type: String
            }
        },
        data(){
            let checkLoginName = (rule, value, callback) => {
                if(this.suppliersVO && this.suppliersVO.id){
                    callback();
                }else{
                    this.$root.checkLoginName(value,function (res) {
                        if(res.code == 1){
                            callback();
                        }else{
                            callback(new Error(res.msg));
                        }
                    });
                }
            };
            return{
                items: [],
                regionalCompanyListPrice: [],
                cityEdit:false,//服务城市是否能编辑
                type: this.$route.query.type,
                supplierId: this.$route.query.supplierId,
                isSendLoading: false,//是否显示loading状态，发送验证码
                isBiddingFlag: 1,
                centerDialogVisible: false,//是否显示注册须知；
                showModal: false,//是否显示弹层遮罩层及关闭按钮
                checked: true,//注册须知是否勾选了已阅读；
                isBidShow: 0,
                formLabelWidth: '250px',
                companyOptions: [],//企业性质
                moneyTypeOptions: [],//币种
                taxiOptions: [],//纳税人状态
                regionalCompanyList: [],

                //供方分类
                categoryTreeList: [],
                categoryTreeListCopy: [],
                treeDialog: false,
                treeData: [],
                defaultCheckedKeys: [],
                selectedSupplierCategorys: [],
                provinceList: [],
                // 个人信息Start
                userRequestVO:{
                    userName: '',
                    password: '',//密码
                    enPassword: '',
                    verificationCode: '',//验证码
                    codeKey: '',//验证码key
                    logoAttachement: [],
                },
                supplierBidOrPrice: {
                  bidOrPrice: 0,
                  supplierCategoryName: '',
                  supplierCategoryId: ''
                },
                // 个人信息End
                supplierBankAccountRules: {
                    accountNo: [{
                        required: true,
                        message: '请输入银行联行号',
                        trigger: 'blur'
                    }, {
                        validator: 'regexp',
                        pattern: /^(\d){9}(\d)*$/,
                        message: '银行联行号不正确',
                        trigger: 'blur'
                    }],
                    bankName: [{
                        required: true,
                        message: '请输入开户银行',
                        trigger: 'blur'
                    }],
                    accountName: [{
                        required: true,
                        message: '请输入开户名称',
                        trigger: 'blur'
                    }],
                    bankNo: [{
                        required: true,
                        message: '请输入银行账号',
                        trigger: 'blur'
                    }, {
                        validator: 'regexp',
                        pattern: /^(\d){9}(\d)*$/,
                        message: '银行账号不正确',
                        trigger: 'blur'
                    }],
                    areaCode: [{
                        required: true,
                        message: '请输入地区代码',
                        trigger: 'change'
                    }],
                    accountType: [{
                        required: true,
                        message: '请输入币种',
                        trigger: 'change'
                    }],
                    areaProvince: [{
                        required: true,
                        message: '请输入省份',
                        trigger: ['blur', 'change']
                    }],
                    areaCity: [{
                        required: true,
                        type: 'number',
                        message: '请输入市县',
                        trigger: ['blur', 'change']
                    }]
                },
                // 企业信息Start
                suppliersVO: {
                    remarks: '',
                    companyName: '',
                    supplierCategoryIds: '',//供应商分类
                    supplierCategoryNames: '',//供应商分类名称
                    supplierServiceCategoryIds: '',//供方服务类别
                    supplierServiceCategoryNames: '',//供方服务类别名称
                    creditLicenseCodeFlag: 1,//信用代码或营业执照号（1：统一社会信用代码， 2：营业执照号）
                    businessLicenseNumber: '', //营业执照号
                    socialCreditCode: '',//统一社会信用代码
                    taxipayerStatus: '', //纳税人状态

                    serviceRegionalCompanyIdsArr: [],
                    serviceRegionalCompanyIds: '',//服务地区公司ids
                    serviceRegionalCompanyNames: '',//服务地区公司名称

                    undertakeAreas: '',
                    undertakeAreasArr:[],

                    headquartersProvince: '',//总部地址省id
                    headquartersProvinceName: '',//总部地址省名称
                    headquartersCity: '',//总部地址市id
                    headquartersCityName: '',//总部地址市名称
                    headquartersArea: '',//总部地址区id
                    headquartersAreaName: '',//总部地址区名称
                    headquartersAddress: '',//总部地址

                    enterpriseCharacterize: '', //企业性质
                    enterpriseCharacterizeRemark: '',//企业性质其他备注
                    enterpriseRegistAddress: '', //企业注册地址
                    officialWebUrl: '', //官网地址

                    legalRepresentative: '', //法定代表人
                    enterpriseRegistrationYear: '',//企业注册年份

                    otherAttachement: [],

                    mainIntentionRegionalCompanyId: '',
                    intentionRegionalCompanyIdsArr: [],
                    intentionRegionalCompanyIds: '',

                    creditLicenseAttachments: [],// 营业执照号/统一社会信用代码
                    taxCertificateNumberAttachments: [],//税务登记证号附件
                    institutionAttachments:[], // 组织机构代码证号附件
                    officeAttachments: [],//办公环境附件
                    taxAttachments: [],//增值税一般纳税人申请认定表
                    auditAttachments: [],//上年审计报告或年营业额证明
                },
                supplierBankAccount: {//银行信息
                    accountName: '',
                    accountNo:'',//银行银行号
                    bankName: '',//开户银行
                    bankNo: '',//银行账号
                    areaCode: '', //地区代码
                    accountType: '', //币种
                    areaProvince: '', //省份
                    areaCity: '', //市县
                },
                supplierBankAccounts:[{//银行信息
                    accountName: '',
                    accountNo:'',//银行银行号
                    bankName: '',//开户银行
                    bankNo: '',//银行账号
                    areaCode: '', //地区代码
                    accountType: '', //币种
                    areaProvince: '', //省份
                    areaCity: '', //市县
                }],
                contactForm: [//联系方式
                    {
                        contactName:'',//联系人
                        mobile:'',//手机
                        phone:'',//电话
                        email:'',//电子邮件
                        creditNumber:'',//身份证号
                        positionName:'',//职位
                        mainFlag:'1',//是否主联系人（0：否，1：是）}
                        secureAttachement: [],
                        contractAttachement: [],
                        attachmentVOList:[],
                    },
                    // {
                    //     contactName:'',//联系人
                    //     mobile:'',//手机
                    //     phone:'',//电话
                    //     email:'',//电子邮件
                    //     creditNumber:'',//身份证号
                    //     positionName:'',//职位
                    //     mainFlag:'0',//是否主联系人（0：否，1：是）}
                    //     secureAttachement: [],
                    //     contractAttachement: [],
                    //     attachmentVOList:[],
                    // }
                ],
// 联系方式End

//资质等级Start
                lstSuppliersQualificationGradeVO: [{
                    qualificationGrade:'',//资质等级
                    qualificationName: '',//资质名称
                    certificateNumber: '',//资质证书编号
                    validityPeriod:'',//资质证书有效期
                    attachmentVOList: [],
                }],//资质等级

                isHideNatural: false,
//资质等级End


// 业绩Start
                suppliersAchievenVO: [//业绩信息
                    {
                        contactName: '',//合同名称
                        signTime: '',//合同签约日期
                        signContactPrice: null,//合作额度
                        lstattachmentVO: [] //合同附件
                    }
                ],
// 业绩End

                otherAttachementVO: {
                    attachments: []
                },
                supplierBidOrPriceRules: {
                    bidOrPrice: [
                        {required: true, message: '请选择招标/采集', trigger: 'blur'},
                    ],
                    supplierCategoryName: [
                        {required: true, message: '请选择招标类别', trigger: ['blur', 'change']},
                    ],
                    // projectOrRegionId: [
                    //     {required: true, message: '请选择项目', trigger: ['blur', 'change']},
                    // ],
                },
                userRequestVORules: {
                    logoAttachement: [
                        {required: true, message: '请选择logo', trigger: 'blur'},
                    ],
                    userName:[
                        {required: true, message: '请输入手机号', trigger: 'blur'},
                        {validator: 'regexp', pattern: /^[0-9]{11}$/, message: '手机号码格式不正确', trigger: 'blur'},
                        {validator: checkLoginName, trigger: 'blur'}
                    ],
                    password:[
                        {required: true, message: '请输入登录密码', trigger: 'blur'},
                        {validator: 'regexp', pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,message: '密码为6-20位数字和字母的组合', trigger: 'blur'},
                        {validator: this.validatePass, trigger: 'blur'}
                    ],
                    enPassword: [
                        {required: true, message: '请再次输入登录密码', trigger: 'blur'},
                        {
                            validator: 'regexp',
                            pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/,
                            message: '密码为6-20位数字和字母的组合',
                            trigger: 'blur'
                        },
                        {validator: this.validatePass2, trigger: 'blur'}
                    ],
                    verificationCode: [{
                        required: true,
                        message: '请输入验证码'
                    }],
                },
                suppliersVORules: Object.assign({
                    companyName: [{
                        required: true,
                        message: '请输入企业名称',
                        trigger: 'blur'
                    }],
                    socialCreditCode:[
                        {required: true, message: '18位数字或字母'},
                        {
                            validator: 'regexp',
                            pattern: /^[A-Za-z0-9]{18}$/,
                            message: '请输入18数字或字母',
                            trigger: 'blur'
                        },
                        { validator: this.checkSocialCode, trigger: 'blur'}
                    ],
                    businessLicenseNumber:[
                        {required: true, message: '13-15位数字或字母'},
                        {
                            validator: 'regexp',
                            pattern: /^[A-Za-z0-9]{13,15}$/,
                            message: '请输入13-15位数字或字母',
                            trigger: 'blur'
                        },
                        { validator: this.checkSocialCode, trigger: 'blur'}
                    ],
                    supplierCategoryNames:[
                        {required: true, message: '请选择供方分类', trigger: 'change'}
                    ],
                }, registerRules),
                naturalRules,
                contactRules: Object.assign(contactRules, {
                    email:[
                        { validator: 'regexp',pattern: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,message:'邮箱格式不正确',trigger:'blur'}
                    ],
                }),
                bankRules,
                suppliersAchievenRules: Object.assign(suppliersAchievenRules, {
                    contactName:[
                        {required: true, message: '请输入合同名称'}
                    ]
                }),

                mapAttachmentOptions: {},//附件清单
            }
        },
        created(){
            let that = this;
            if(!that.type){
                that.type = that.detailType;
            }

            if(!that.supplierId){
                that.supplierId = that.id;
            }

            if(!that.supplierId){
                this.centerDialogVisible = true;
            }

            that.getTreeList();
            that.getProvinceList();
            that.getRegionalCompanyList();
            if(this.supplierId){
                that.getSupplierDetail();
            }
        },
        mounted(){
            this.getType('enterprise_characterize');//获取企业性质
            this.getType('money_type');//获取企业性质
            this.getType('taxipayer_status');//获取纳税人状态
            this.getData()
        },
        computed: {
            isReadOnly(){
                if(this.type == 1 || this.type == 2){
                    return true;
                }else {
                    return false;
                }
            },
            isClearable(){
                if(this.type == 1 || this.type == 2){
                    return false;
                }else {
                    if(this.supplierId && this.supplierId.length >0){
                        return false;
                    }
                    return true;
                }
            },
        },
        methods:{
            // 切换招标采集清空项目名称，招标类别
            handleClear() {
              this.supplierBidOrPrice.projectOrRegionId = ''
              this.supplierBidOrPrice.supplierCategoryId = ''
              this.supplierBidOrPrice.supplierCategoryName = ''
              if(this.supplierBidOrPrice.bidOrPrice == 0) {
                    this.supplierBidOrPriceRules.projectOrRegionId[0].message = '请选择项目'
              }else {
                this.supplierBidOrPriceRules.projectOrRegionId[0].message = '请选择区域'
              }
              this.$forceUpdate()
            },
            selectedCategory(val) {
              this.supplierBidOrPrice.supplierCategoryName = val.categoryName;
              // this.userRequestVO.purchaseCategoryId = val.id;
              this.supplierBidOrPrice.supplierCategoryId = val.id;
              // this.userRequestVO.parentCategoryCode = val.parentCategoryCode;
              // this.userRequestVO.categoryCode = val.categoryCode;
              console.log(val, 'sdsdsdsdsd');
              
              // this.$refs["extWFlowForm2"].clearValidate("purchaseCategoryName");
              this.$forceUpdate()
            },
            chooseCategory() {
              this.$refs["selectCategory"].show();
            },
            getData(){
              let that = this;
              that.$root.postFunc('/v1/sProject/public/getProjectListByRegionalCompanyId',{'pageFlag': 0, 'pageNumber': 0, 'pageSize': 0, 'regionalCompanyId': ""},function (res) {
                that.items = res.data.data;
              });
              that.$root.postFunc('/v1/sRegionalCompany/public/getRegionalCompanyList', {}, function (res) {
                that.regionalCompanyListPrice = res.data.data.list;
              });
            },
            businessLicenseNumberInput(val){
                // debugger;
                //console.log(val);
                let codeReg = new RegExp("[A-Za-z0-9]+"), //正则 英文+数字；
                len=val.length,
                str='';
                for(var i=0;i<len;i++){
                    if(codeReg.test(val[i])){
                        str+=val[i];
                    }
                }
                // debugger;
                this.suppliersVO.businessLicenseNumber=str;
            },
            socialCreditCodeInput(val){
                //console.log(val);
                let codeReg = new RegExp("[A-Za-z0-9]+"), //正则 英文+数字；
                len=val.length,
                str='';
                for(var i=0;i<len;i++){
                    if(codeReg.test(val[i])){
                        str+=val[i];
                    }
                }
                // debugger;
                this.suppliersVO.socialCreditCode=str;
            },
            chagePwd(){//修改密码
                this.$router.push('/changePwd')
            },
            sendCode(){//发送验证码
                var _this = this;
                var countDownEl = document.querySelector('.countDown');
                var sendCodeEl = document.querySelector('.sendCode');
                _this.$refs.userRequestVO.validateField('userName',function(err){
                    if(!err){//如果没有错误信息，就代表手机号验证通过了，就发送验证码；
                        _this.isSendLoading = true;
                       _this.$root.getHttp(`v1/login/public/sendSmsCode/${_this.userRequestVO.userName}`,function(res){
//                           console.log('验证码',res);
                           _this.isSendLoading = false;
                           countDownEl.style.display = 'inline-block';//发送成功,显示倒计时；
                           sendCodeEl.style.display = 'none';
                           var time = setInterval(function(){
                               if(parseInt(countDownEl.innerHTML) == 1){
                                   countDownEl.innerHTML = '60S';
                                   countDownEl.style.display = 'none';
                                   sendCodeEl.style.display = 'inline-block';
                                   clearInterval(time);
                                   return;
                               }
                               countDownEl.innerHTML = parseInt(countDownEl.innerHTML)-1 + 'S';
                           },1000);

                       })
                    } else {
                        console.log('error')
                    }
                })
            },
            toIndex(){
                let isLogin = window.sessionStorage.getItem('refresh_token') ? true : false;
                if(isLogin){
                    this.$router.go(-1)
                }else {
                    this.$root.activeIndex = 'home';
                    this.$router.push('/');
                }
            },
            toRegister(){
                if(this.checked) {
                   this.centerDialogVisible = false;
                } else {
                    this.$alert('请先勾选"已阅读注册须知"', '提示', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    });
                }
                this.$confirm('是否参与投标?', '提示', {
                    confirmButtonText: '参与',
                    cancelButtonText: '不参与',
                    closeOnClickModal: false,
                    showClose: false,
                    type: 'warning'
                    }).then(() => {
                        this.isBiddingFlag = 1
                    }).catch(() => {
                        this.isBiddingFlag = 0        
                    });
            },
            toLogin(){
                this.$router.push('/');
            },
            toHelp(){
                this.$root.activeIndex = 'setting';
                this.$router.push('/help');
            },
            getSupplierDetail(){
                let that = this;
                this.$root.getHttp('/v1/sSuppliers/getOutSSuppliersHS/'+this.supplierId, (res) => {
                    that.userRequestVO = res.data.data.userRequestVO;
                    that.suppliersVO = res.data.data.suppliersVO;
                    that.cityEdit = !!res.data.data.suppliersVO.mainIntentionRegionalCompanyId;
                    if(!that.suppliersVO.creditLicenseCodeFlag){
                        that.suppliersVO.creditLicenseCodeFlag = 1
                    }
                    if(!that.suppliersVO.taxipayerStatus){
                        that.suppliersVO.taxipayerStatus= ''
                    }
                    if(!that.suppliersVO.enterpriseCharacterize){
                        that.suppliersVO.enterpriseCharacterize= ''
                    }
                    that.suppliersVO.taxipayerStatus = that.suppliersVO.taxipayerStatus + '';
                    that.supplierBankAccounts = res.data.data.supplierBankAccounts || [{...that.supplierBankAccount}]

                    let contactFormData = res.data.data.lstSuppliersContactInfoVO || [];
                    if(contactFormData.length>0){
                       that.contactForm = res.data.data.lstSuppliersContactInfoVO;
                    }
                    // that.contactForm = res.data.data.lstSuppliersContactInfoVO;
                    that.userRequestVO.logoAttachement = res.data.data.mapAttachmentVOs[46] || [];
                    that.suppliersVO.otherAttachement = res.data.data.mapAttachmentVOs[12] || [];


                    for(let key in res.data.data.mapAttachmentVOs){
                        if(!that.mapAttachmentOptions[key]){
                            that.mapAttachmentOptions[key] = {}
                        }
                        that.mapAttachmentOptions[key].fileList = res.data.data.mapAttachmentVOs[key] || [];
                    }

                    that.suppliersVO.creditLicenseAttachments = res.data.data.mapAttachmentVOs[2] || [];
                    that.suppliersVO.taxCertificateNumberAttachments = res.data.data.mapAttachmentVOs[50] || [];
                    that.suppliersVO.institutionAttachments = res.data.data.mapAttachmentVOs[51] || [];
                    that.suppliersVO.officeAttachments = res.data.data.mapAttachmentVOs[52] || [];
                    that.suppliersVO.taxAttachments = res.data.data.mapAttachmentVOs[3] || [];
                    that.suppliersVO.auditAttachments = res.data.data.mapAttachmentVOs[4] || [];
                    that.otherAttachementVO.attachments = res.data.data.mapAttachmentVOs[53] || [];

                    if(this.supplierId){
                        that.lstSuppliersQualificationGradeVO = res.data.data.lstSuppliersQualificationGradeVO || [];
                        that.suppliersAchievenVO = res.data.data.suppliersAchievenVO || [];
                        if(that.lstSuppliersQualificationGradeVO.length == 0 && !that.isReadOnly){
                            that.lstSuppliersQualificationGradeVO = [{
                                qualificationGrade:'',//资质等级
                                qualificationName: '',//资质名称
                                certificateNumber: '',//资质证书编号
                                validityPeriod:'',//资质证书有效期
                                attachmentVOList: [],
                            }]
                        }

                        if(that.suppliersAchievenVO.length == 0 && !that.isReadOnly){
                            that.suppliersAchievenVO = [//业绩信息
                                {
                                    contactName: '',//合同名称
                                    signTime: '',//合同签约日期
                                    signContactPrice: null,//合作额度
                                    lstattachmentVO: [] //合同附件
                                }
                            ];
                        }
                    }


                    if(that.contactForm){
                        that.contactForm.forEach(contactFormItem => {
                            contactFormItem.secureAttachement = [];
                            contactFormItem.contractAttachement = [];
                            contactFormItem.attachmentVOList.forEach(item => {
                                if(item.attachmentType == 47){
                                    contactFormItem.secureAttachement.push(item);
                                }
                                if(item.attachmentType == 48){
                                    contactFormItem.contractAttachement.push(item);
                                }
                            });
                        })
                    }

                    if(that.contactForm.attachmentVOList){
                        that.contactForm.attachmentVOList.forEach(item => {
                            if(item.attachmentType == 47){
                                that.contactForm
                            }
                        });
                    }

                    if(that.supplierBankAccounts.length>0){
                        that.supplierBankAccounts.forEach(item=>{
                            if(item.areaProvince){
                                item.areaProvince = parseInt(item.areaProvince);
                                that.$root.postHttp('/v1/sysStandardArea/public/getStandardAreaList/',{
                                    "level": '2',
                                    'parentId': item.areaProvince,
                                },function (res) {
                                    item.areaCityList = res.data.data;
                                    that.$forceUpdate()
                                });
                            }
                            if(item.areaCity){
                                item.areaCity = parseInt(item.areaCity);
                            }
                            if(item.accountType){
                                item.accountType = item.accountType + '';
                            }
                        })
                    }

                    that.suppliersVO.enterpriseCharacterize = that.suppliersVO.enterpriseCharacterize + '';

                    that.suppliersVO.intentionRegionalCompanyIds = that.suppliersVO.intentionRegionalCompanyIds || '';
                    if(that.suppliersVO.intentionRegionalCompanyIds!='' && that.suppliersVO.intentionRegionalCompanyIds!=null){
                        that.$set(that.suppliersVO, 'intentionRegionalCompanyIdsArr', that.suppliersVO.intentionRegionalCompanyIds.split(','));
                    }
                    if(that.suppliersVO.supplierCategoryIds && that.suppliersVO.supplierCategoryNames){
                        let selectedCategoryIdArr = that.suppliersVO.supplierCategoryIds.split(',');
                        let selectedCategoryNameArr = that.suppliersVO.supplierCategoryNames.split(',');
                        for(let i=0; i<selectedCategoryIdArr.length; i++){
                            that.selectedSupplierCategorys.push({
                                id: selectedCategoryIdArr[i],
                                categoryName: selectedCategoryNameArr[i]
                            });
                        }
                    }

                   console.log(that.userRequestVO);
                });
            },
            selectedIntentionRegional(){
                if(this.suppliersVO.intentionRegionalCompanyIdsArr && this.suppliersVO.intentionRegionalCompanyIdsArr.length>0){
                    this.suppliersVO.intentionRegionalCompanyIds = this.suppliersVO.intentionRegionalCompanyIdsArr.join(',');
                }else{
                    this.suppliersVO.intentionRegionalCompanyIds = '';
                }
            },
            getType(type){
                this.$root.getHttp('v1/sysDict/public/getDictListByDictType?dictType=' + type, (res) => {
                    if (type == 'enterprise_characterize') {
                        this.companyOptions = res.data.data;//获取企业性质
                    }
                    if (type == 'money_type') {
                        this.moneyTypeOptions = res.data.data;//获取企业性质
                    }
                    if (type == 'taxipayer_status') {
                        this.taxiOptions = res.data.data;//获取企业性质
                    }

                });
            },
            finishUpload(fileType, fileList, contactForm){
                this.checkForm();
                if(contactForm){
                    // contactForm.sAttaches = [...contactForm.secureAttachement, ...contactForm.contractAttachement];
                }else{
                    this.mapAttachmentOptions[fileType] = fileList;
                }
            },
            addStrategy(){//添加战略合作
                var _this = this;
                var item = {
                    cooperativeStartTime: '',//合作起始时间
                        cooperativeEndTime: '',//合作截止时间
                        cooperationAmount: null,//合作额度
                        lstattachmentVO: [] //合同附件
                };
                _this.suppliersAchievenVO.push(item);
            },
            removeStrategy(index){//移除战略合作
                var form = 'suppliersAchievenVO'+index;
                this.$refs[form][0].resetFields();
                this.suppliersAchievenVO.splice(index,1);
            },
            addBankInfo(){
                this.supplierBankAccounts.push({})
            },
            addContact(){//新增联系人
                this.contactForm.push(
                    {
                        contactName:'',//联系人
                        mobile:'',//手机
                        phone:'',//电话
                        email:'',//电子邮件
                        creditNumber:'',//身份证号
                        positionName:'',//职位
                        mainFlag:'0',//是否主联系人（0：否，1：是）}
                        secureAttachement: [],
                        contractAttachement: [],
                        attachmentVOList:[],
                    }
                );
            },
            removeBankInfo(index){//删除联系人
                this.supplierBankAccounts.splice(index,1);
            },
            removeContact(index){//删除联系人
                var form = 'contactForm'+index;
                this.$refs[form][0].resetFields();
                this.contactForm.splice(index,1);
                for(var i = 1;i < this.contactForm.length;i++){
                    this.$refs['contactForm'+i][0].validate(function(val){
                        console.log(val)
                    });
                }
            },
            addNatural(){//新增资质等级
                this.isHideNatural = false;
                this.lstSuppliersQualificationGradeVO.push(
                    {
                        qualificationGrade:'',//资质等级
                        qualificationName: '',//资质名称
                        certificateNumber: '',//资质证书编号
                        validityPeriod:'',//资质证书有效期
                        attachmentVOList: [],
                    }
                );
            },
            removeNatural(index){//删除资质等级
                var form = 'naturalForm'+index;
                this.$refs[form][0].clearValidate();
                this.lstSuppliersQualificationGradeVO.splice(index,1);
                // this.lstSuppliersQualificationGradeVO = this.lstSuppliersQualificationGradeVO;
                // console.log(this.lstSuppliersQualificationGradeVO);

                if(this.lstSuppliersQualificationGradeVO.length == 0){
                    this.isHideNatural = true;
                }
                for(var i = 0;i < this.lstSuppliersQualificationGradeVO.length;i++){
                    this.$refs['naturalForm'+i][0].validate(function(val){
                        console.log(val)
                    });
                }
            },
            validatePass(rule, value, callback){//验证密码
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    if (this.userRequestVO.enPassword !== '') {
                        this.$refs.userRequestVO.validateField('enPassword');
                    }
                    callback();
                }
            },
            validatePass2(rule, value, callback){//验证确认密码
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.userRequestVO.password) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            },
            checkSocialCode(rule,value,callback){
//                console.log(value)
                if(this.supplierId){
                    callback();
                    return;
                }
                if(this.isBiddingFlag != 1)  return
                var _this = this;
                this.$root.postHttp('/v1/sSuppliers/public/checkCodeOrNumber',{
                    "businessLicenseNumber": _this.suppliersVO.businessLicenseNumber,
                    "creditLicenseCodeFlag": _this.suppliersVO.creditLicenseCodeFlag,
                    "socialCreditCode":  _this.suppliersVO.socialCreditCode,
                    "supplierId": ''
                }, function(res){
                    console.log(res);
                    if(res.data.code == 1){
                        callback();
                    } else {
                        callback(new Error(res.data.msg));
                    }
                })
            },
            handleChange(idx, item) {
                if(idx == 0 && item.mobile) {
                    this.userRequestVO.userName = item.mobile
                }
            },
            getRegionalCompanyList(){
                let that = this;
                // （1:省份province,2:市city,3:区县district,4:街道street）
                that.$root.postHttp('/v1/sRegionalCompany/public/getRegionalCompanyList',{},function (res) {
                    that.regionalCompanyList = res.data.data.list;
                });

            },
            getProvinceList(){
                let that = this;
                that.$root.postHttp('/v1/sysStandardArea/public/getStandardAreaList',{
                    "level": '1',
                },function (res) {
                    that.provinceList = res.data.data;
                });
            },
            cityValue(){
                this.$forceUpdate()
            },
            handelSelectChangeFunc(val,index){
                let that = this;
                this.supplierBankAccounts[index].areaCity = '';
                that.$root.postHttp('/v1/sysStandardArea/public/getStandardAreaList',{
                    "level": '2',
                    'parentId': val,
                },function (res) {
                    that.supplierBankAccounts[index].areaCityList = res.data.data;
                    that.$forceUpdate()
                });
            },
            //获取供方分类完整树形数据
            getTreeList(){
                let that = this;
                that.$root.postHttp('/v1/sSuppliersCategory/public/findSuppliersCategoryTreeList',{
                    "categoryStatus": '1',
                    "pageFlag": 0,
                    "pageNumber": 0,
                    "pageSize": 0
                },function (res) {
                    that.categoryTreeList = res.data.data.tree;
                    that.getNewList(res.data.data.tree);
                });
            },
            selectSupplierCategoryIds(){
                let that = this;
                that.treeData = that.categoryTreeList;
                that.treeDialog = true;
            },
            getNewList(arr){
                let that = this;
                for(let i=0; i<arr.length; i++){
                    that.categoryTreeListCopy.push(arr[i]);
                    if(arr[i].children != null){
                        that.getNewList(arr[i].children)
                    }
                }
            },
            getHighestLevel(parentId,level){
                let that = this;
                let levelId = '';
                let levelParentId = '';
                let levelName = '';
                let obj = {};
                for(let i=0;i<that.categoryTreeListCopy.length;i++){
                    if(parentId == that.categoryTreeListCopy[i].id){
                        levelId = that.categoryTreeListCopy[i].id;
                        levelParentId = that.categoryTreeListCopy[i].parentId;
                        levelName = that.categoryTreeListCopy[i].categoryName;
                    }
                }
                if(level == 3){
                    for(let i=0;i<that.categoryTreeListCopy.length;i++){
                        if(levelParentId == that.categoryTreeListCopy[i].id){
                            levelId = that.categoryTreeListCopy[i].id;
                            levelName = that.categoryTreeListCopy[i].categoryName;
                        }
                    }
                }
                obj = {
                    id: levelId,
                    name: levelName
                };
                return obj;
            },
            handleClickChange(val,node){
                let that = this;
                if(node.checked){
                    that.$refs['categoryTree'].setChecked(val.id, false, true);
                }else{
                    that.$refs['categoryTree'].setChecked(val.id, true, true);
                }
            },
            treeConfirm(){
                let that = this;
                let selectedData = that.$refs['categoryTree'].getCheckedNodes(true);
                let selectedSupplierServiceCategoryIdsArr = [];
                let selectedSupplierServiceCategoryNamesArr = [];
                for(let i=0; i<selectedData.length; i++){
                    if(selectedData[i].categoryLevel == 1){
                        selectedSupplierServiceCategoryIdsArr.push(selectedData[i].id);
                        selectedSupplierServiceCategoryNamesArr.push(selectedData[i].categoryName);
                    }else{
                        let obj = that.getHighestLevel(selectedData[i].parentId,selectedData[i].categoryLevel)
                        selectedSupplierServiceCategoryIdsArr.push(obj.id);
                        selectedSupplierServiceCategoryNamesArr.push(obj.name);
                    }
                }
                if(that.$root.uniqueArr(selectedSupplierServiceCategoryIdsArr).length != 1){
                    that.$message.error('只能在同一大类下选择供方分类');
                    return false;
                }

                let supplierCategoryIdsArr = [];
                let supplierCategoryNamesArr = [];
                for(let i=0; i<selectedData.length; i++){
                    supplierCategoryIdsArr.push(selectedData[i].id);
                    supplierCategoryNamesArr.push(selectedData[i].categoryName);
                }
                that.suppliersVO.supplierCategoryIds = supplierCategoryIdsArr.join(',');
                that.suppliersVO.supplierCategoryNames = supplierCategoryNamesArr.join(',');
                that.suppliersVO.supplierServiceCategoryIds = that.$root.uniqueArr(selectedSupplierServiceCategoryIdsArr).join(',');
                that.suppliersVO.supplierServiceCategoryNames = that.$root.uniqueArr(selectedSupplierServiceCategoryNamesArr).join(',');
                that.selectedSupplierCategorys = selectedData;
                that.treeDialog = false;
            },
            cancelAddFnc(){
                window.close();
            },

            reduce(arr) {
                var sequence = Promise.resolve()

                arr.forEach(function(item) {
                    sequence = sequence.then(item)
                })

                return sequence
            },

            checkForm(){
                let checkValidator = [];
                checkValidator.push(this.submitFormFnc('userRequestVO'));
                checkValidator.push(this.submitFormFnc('suppliersVO'));
                checkValidator.push(this.submitFormFnc('supplierBidOrPrice'));
                // debugger
                if(this.supplierBankAccounts.length){
                    this.supplierBankAccounts.forEach((item,index)=>{
                        checkValidator.push(this.submitFormFnc('supplierBankAccount'+index));
                    })
                }

                this.lstSuppliersQualificationGradeVO.forEach((item, index) => {
                    checkValidator.push(this.submitFormFnc('naturalForm'+index));
                })

                this.contactForm.forEach((item, index) => {
                    checkValidator.push(this.submitFormFnc('contactForm'+index));
                })

                this.suppliersAchievenVO.forEach((item, index) => {
                    checkValidator.push(this.submitFormFnc('suppliersAchievenVO'+index));
                })

                let checkPromise = [];
                checkPromise.push(this.submitFormPromise('userRequestVO'));
                checkPromise.push(this.submitFormPromise('suppliersVO'));
                checkPromise.push(this.submitFormPromise('supplierBidOrPrice'));
                this.supplierBankAccounts.forEach((item,index)=>{
                    checkPromise.push(this.submitFormPromise('supplierBankAccount'+index));
                })
                this.contactForm.forEach((item, index) => {
                    checkPromise.push(this.submitFormPromise('contactForm'+index));
                })

                this.suppliersAchievenVO.forEach((item, index) => {
                    checkPromise.push(this.submitFormPromise('suppliersAchievenVO'+index));
                })

                this.lstSuppliersQualificationGradeVO.forEach((item, index) => {
                    checkPromise.push(this.submitFormPromise('naturalForm'+index));
                })


                return Promise.all(checkPromise).then(data=>{
                    return data;
                })
                .catch(e => {
                    console.log(e);
                    reject(e);
                });
            },
            checkFormBidd() {
                let checkPromise = [];
                checkPromise.push(this.submitFormPromise('userRequestVO'));
                let form = this.$refs['suppliersVO'];
                form.validate((valid) => {
                    if(valid){
                        resolve(true);
                    } else {
                        reject('请完成必填信息的填写！');
                    }
                });
                checkPromise.push(this.submitFormPromise('supplierBankAccount'));
                // console.log(this.contactForm)
                this.contactForm.forEach((item, index) => {
                    checkPromise.push(this.submitFormPromise('contactForm'+index));
                })
                return Promise.all(checkPromise).then(data=>{
                    return data;
                })
                    .catch(e => {
                        console.log(e);
                        // reject(e);
                    });
            },
            submit(){
               let that = this;
               console.log('wq')
               if(that.isBiddingFlag == 1) {
                    this.checkForm().then((res)=>{
                        if(this.suppliersAchievenVO.length < 3){
                            this.$alert('请至少填写3个业绩信息！',{
                                type: 'warning'
                            });
                            return;
                        }

                        this.contactForm.forEach((item, index) => {
                            // secureAttachement: [],
                            // contractAttachement: [],
                            item.attachmentVOList = item.secureAttachement.concat(item.contractAttachement);
                        })

                        var formParams = {
                            "userRequestVO": this.userRequestVO,
                            // "userRequestVO": JSON.parse(JSON.stringify(this.userRequestVO)),
                            "suppliersVO":  this.suppliersVO,
                            "supplierBidOrPrice":  this.supplierBidOrPrice,
                            "supplierBankAccounts": this.supplierBankAccounts,
                            "lstSuppliersQualificationGradeVO": this.lstSuppliersQualificationGradeVO,
                            "lstSuppliersContactInfoVO": this.contactForm,
                            "suppliersAchievenVO": this.suppliersAchievenVO,
                            "mapAttachmentVOs": {} //附件清单
                        };

                        if (formParams.mainIntentionRegionalCompanyId){
                            formParams.serviceRegionalCompanyIds = formParams.intentionRegionalCompanyIds + ',' + formParams.mainIntentionRegionalCompanyId;
                        }
                        
                        for(let key in this.mapAttachmentOptions){
                            formParams.mapAttachmentVOs[key] = this.mapAttachmentOptions[key].fileList;
                        }

                        formParams.isBiddingFlag = this.isBiddingFlag
                        if(this.suppliersVO.id){
                            this.$root.postHttp('/v1/sSuppliers/outerUpdateSuppliersHS',formParams,function(res){
                                that.$alert('编辑成功', '提示', {
                                    confirmButtonText: '确定',
                                    type: 'success',
                                    callback: action => {
                                        that.$router.go(-1);
                                    }
                                });
                            },function(){

                            })
                        }else {
                            formParams.userRequestVO.password = md5(formParams.userRequestVO.password);
                            this.$root.postHttp('/v1/sSuppliers/public/outerSaveSuppliersHS',formParams,function(res){
                                that.$alert('注册成功', '提示', {
                                    confirmButtonText: '确定',
                                    type: 'success',
                                    callback: action => {
                                        that.$router.go(-1);
                                    }
                                });
                                setTimeout(function () {
                                    window.close();
                                },2000)
                            },function(){

                            })
                        }

                    }).catch(e=>{
                        // debugger;
                        console.log(e);
                        this.$alert('请完成必填信息的填写！',{
                            type: 'warning'
                        });
                    });
               }else {
                this.checkFormBidd().then((res)=>{
                    if (Array.isArray(res)){
                        let formParams = {
                            saveFlag: 1,
                            "userRequestVO": this.userRequestVO,
                            "suppliersVO": this.suppliersVO,
                            "supplierBankAccounts": this.supplierBankAccounts,
                            "lstSuppliersContactInfoVO": this.contactForm,
                            "mapAttachmentVOs": {}, //附件清单
                            isBiddingFlag: this.isBiddingFlag
                        };
                        // console.log(JSON.stringify(formParams))
                        if(this.suppliersVO.id){
                            this.$root.postHttp('/v1/sSuppliers/outerUpdateSuppliersHS',formParams,function(res){
                                that.$alert('编辑成功', '提示', {
                                    confirmButtonText: '确定',
                                    type: 'success',
                                    callback: action => {
                                        that.$router.go(-1);
                                    }
                                });
                            },function(){

                            })
                        }else {
                            formParams.userRequestVO.password = md5(formParams.userRequestVO.password);
                            this.$root.postHttp('/v1/sSuppliers/public/outerSaveSuppliersHS',formParams,function(res){
                                that.$alert('注册成功', '提示', {
                                    confirmButtonText: '确定',
                                    type: 'success',
                                    callback: action => {
                                        that.$router.go(-1);
                                    }
                                });
                                setTimeout(function () {
                                    window.close();
                                },2000)
                            },function(){

                            })
                        }
                    }else{
                        this.$alert('请完成必填信息的填写！',{
                            type: 'warning'
                        });
                    }
                }).catch(e=>{
                    this.$alert('请完成必填信息的填写！',{
                        type: 'warning'
                    });
                });
               }
                


                // if(Array.isArray(that.formDataInfo.intentionRegionalCompanyIds)){
                //             that.formDataInfo.intentionRegionalCompanyIds = that.formDataInfo.intentionRegionalCompanyIds.join(',');
                //         }
                //         that.$root.postHttp('/v1/sSuppliersIntranet/addSuppliersIntranet',that.formDataInfo,function (res) {
                //             that.$alert(res.msg,{
                //                 type: 'success',
                //                 callback: () => {
                //                     that.cancelAddFnc();
                //                 }
                //             });
                            // setTimeout(function () {
                            //     window.close();
                            // },2000)
                //         });
            },
            submitFormFnc(formName){
                let that = this;
                var f = function (){
                    const p = new Promise((resolve, reject) => {
                        let form = that.$refs[formName];
                        if(Array.isArray(that.$refs[formName])){
                            form = that.$refs[formName][0]
                        }
                        form.validate((valid) => {
                            if(valid){
                                resolve(true);
                            } else {
                                reject('请完成必填信息的填写！');
                            }
                        });
                    });
                    return p;
                }
                return f;
            },
            submitFormPromise(formName){
                return this.submitFormFnc(formName)();
            },
            queryByQcc(){//企查查
                var _this = this;
                this.$root.postHttpAddit('/v1/qcc/public/getBasicDetailsByName',{
                    "companyName": _this.suppliersVO.companyName
                }, function(res){
                    if(res.data.Status == '200'){
                        let result = res.data.Result;
                        if(result){
                            _this.suppliersVO.legalRepresentative=result.OperName;//法定代表人
                            _this.suppliersVO.enterpriseRegistrationYear=result.StartDate;//企业注册年份
                            _this.suppliersVO.socialCreditCode=result.CreditCode;//统一社会信用代码
                            _this.suppliersVO.headquartersAddress=result.Address;//总部地址
                            _this.suppliersVO.enterpriseRegistAddress=result.Address;//企业注册地址
                            _this.suppliersVO.registeredCapital=result.RegistCapi.replace('万元人民币','');//注册资本
                            _this.suppliersVO.orgCertificateNumber=result.OrgNo;//组织机构代码证号

                        }
                    }
                });
            },
            mainChanged(){
                // debugger
                if (this.suppliersVO.intentionRegionalCompanyIdsArr.indexOf(this.suppliersVO.mainIntentionRegionalCompanyId)>=0){
                    this.suppliersVO.intentionRegionalCompanyIdsArr = this.suppliersVO.intentionRegionalCompanyIdsArr.filter(
                        item=>{
                            return this.suppliersVO.mainIntentionRegionalCompanyId != item
                        }
                    )
                }
            }
        },
    }
</script>

<style scoped lang="scss">
    @import '../../assets/_var.scss';
    @import "../../assets/iconfont/iconfont.css";

    /*头部导航*/
    .registerHeader {
        background: #fff;
        & .main-container {
            overflow: hidden;
            padding: 18px 0;
            height: 80px;
            box-sizing: border-box;
            line-height: 34px;
        }
        & .left_h {
            float: left;
            & .logoImg {
                display: inline-block;
                vertical-align: middle;
                & img {
                    /*width: 240px;*/
                    height: 29px;
                }
            }
            & span {
                margin-left: 20px;
                font-size: 16px;
            }
        }
        & .right_h {
            float: right;
            & .help {
                display: inline-block;
                padding: 0 20px 0 25px;
                background: url('../../assets/images/register/icon01.png') no-repeat left center;
            }
            & .help:hover,
            & .wechat:hover {
                color: $--text-color-light;
            }
            & .wechat {
                display: inline-block;
                padding: 0 0 0 43px;
                background: url('../../assets/images/register/icon02.png') no-repeat 15px center;
            }
            .line {
                display: inline-block;
                width: 1px;
                height: 14px;
                background: $--text-color-lighter;
            }
        }
        & a {
            font-size: 14px;
            color: $--text-color-lighter;
        }
    }
    /*banner*/
    #registerTotal .banner {
        margin: 0 0 30px;
        & img {
            width: 100%;
            height: 150px;
        }
    }

    .main-container{
        margin-top: 70px;
        width: 1120px;
        text-align: left;
    }
    .container /deep/{
        padding-bottom: 15px;
        background-color: #ffffff;

        & .el-form-item__content {
            & .countDown {
                background: #cb1235;
                position: absolute;
                right: -100px;
                top: 4px;
                width: 88px;
                height: 32px;
                line-height: 32px;
                cursor: pointer;
                color: #fff;
                border-radius: 3px;
                text-align: center;
            }
        }

        & .unit {
            width: 100px;
            margin-right: 5px;
        }

        & .tip {
            margin-left: 10px;
            color: $--primary-color;
            font-size: 12px;
        }

         & .add {
            float: right;
            font-size: 14px;
            cursor: pointer;
            & img {
                vertical-align: middle;
                width: 70px;
                height: 26px;
            }
        }
        & .dele {
            position: absolute;
            top: 3px;
            right: 25px;
        }
        & .dele img {
            transform: scale(1);
            transition: .5s;
            width: 34px;
            height: 34px;
        }
        .dele:hover img {
            transform: scale(1.1);
        }
        & .remarks {
            width: 95%;
        }

        & .naturalForm  {
            // padding: 20px 10px 5px;
            // padding-left: 0px;
            // padding-right: 26px;
            // border: 1px solid #dcdfe6;
            // border-radius: 3px;
            // margin-bottom: 20px;
        }

        & h4{
            padding: 0 30px;
            text-align: left;
            line-height: 50px;
            color: $--text-color-light;
            background: $--secondary-fill-color;
            overflow: hidden;
            position: relative;
            .dele {
                top: 0px;
            }
        }
        & h4 {
            text-indent: 10px;
            line-height: 35px;
            background: $--primary-fill-color;
        }

        .attachmentForm {
            position: relative;
            .el-form-item__content {
                width: 250px;
                .file-name {
                    max-width: 174px;
                }
            }
        }

        .remarkForm {
            width: 100%;
            .el-form-item__content {
                width: calc(100% - 250px);
            }
        }

        .el-form-item__error {
            width: 250px;
        }

        .el-input__inner {
            border: none;
            border-bottom: 1px solid #C4C4C4;
            border-radius: 0px;
        }

        .el-input.is-disabled .el-input__inner {
            background-color: white;
        }

        .el-form-item {
            width: 100%;
        }
        .el-form-item__error {
            width: 300px;
            padding: 0;
        }

        .el-form-item__label, .el-form-item__content{
            line-height: 33px;
        }
    }
    .box-card{
        margin-bottom: 15px;
    }
    .minWidth{
        width: 250px;
    }

    h3{
        // background-color: #ececec;
        padding: 5px 20px;
        margin: 0;
        // margin-top: 10px;
        position: relative;
    }

    .iconxiala::before {
        position: absolute;
        left: -5px;
        font-size: 20px;
    }

    .colorLine {
        margin-bottom: 20px;
        padding-left: 20px;
    }

    h2 {
        font-size: 13px;
        margin-left: 20px;
    }
    .noMarginBottom{
        // margin-bottom: 0!important;
        margin-bottom: 15px!important;
        .tipWrap {
            position: relative;
            min-width: 250px;
            .tips {
                position: absolute;
                top: 16px;
                left: 100px;
                padding-left: 20px;
                font-size: 12px;
                color: $--text-color-light;
                background: url('../../assets/images/register/tip.png') no-repeat left center;
            }
        }
    }


    /*注册须知*/
    #article {
        & .el-dialog {
            border-radius: 15px;
        }
        & .el-dialog__header {
            text-align: left;
            font-weight: bold;
            border-bottom: 1px solid $--text-color-light;
        }
        .el-dialog__title {
            padding-left: 30px;
            background: url('../../assets/images/register/icon_tit.png') no-repeat 0 1px;
        }
        .el-dialog--center .el-dialog__body {
            height: 320px;
            overflow-y: scroll;
        }
        & .center {
            text-align: center;
        }
        & section {
            margin-top: 15px;
            padding: 10px;
            color: $--primary-color;
            border: 1px solid $--secondary-fill-color;
        }
        & .padd {
            padding: 5px 0;
        }
        & .indent {
            text-indent: 28px;
        }
        & .indent2 {
            text-indent: 38px;
            /*padding: 0 14px;*/
        }
        & .readed {
            /*margin-top: 20px;*/
            padding: 15px;
            border-top: 1px dashed $--text-color-lighter;
            text-align: left;
        }
        & .el-button{
            padding: 10px 36px;
        }
        & .disagree {
            background: $--text-color-lighter;
            border: none;
        }
        & .el-dialog__footer {
            padding: 0 20px 20px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/common/Register.vue